import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './main.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// Layouts
import HighSchoolLayout from './layout/HighschoolLayout.jsx';
import PrimaryschoolLayout from './layout/PrimaryschoolLayout.jsx';
import Admissions from './pages/Admissions'; 

// Primary School Pages
import PrimaryHome from './primary/PrimaryHome.jsx';
import PrimaryAcademic from './primary/PrimaryAcademic.jsx';
import PrimaryFacilities from './primary/PrimaryFacilities.jsx';
import OurPillars from './pages/OurPillars.jsx';  // Reuse if shared
import PrimaryFees from './primary/PrimaryFees.jsx';
// if that's the actual file name
    // Reuse if shared

// High School Pages
import Home from './components/Home.jsx';
import Academics from './pages/Academics.jsx';
import HighSchoolFacilities from './pages/HighSchoolFacilities.jsx';
import Contact from './pages/Contact.jsx';
import HowToPay from './pages/HowToPay.jsx';


// Main Entry Page
import MainHome from './pages/mainHome.jsx';

function App() {
  return (
    <Router>
      <Routes>
        {/* Main Landing Page */}
        <Route path="/" element={<MainHome />} />

        {/* Primary School Section */}
  <Route path="/primary-school" element={<PrimaryschoolLayout />}>
  <Route index element={<PrimaryHome />} />
  <Route path="academic" element={<PrimaryAcademic />} />
  <Route path="facilities" element={<PrimaryFacilities />} />
  <Route path="our-pillars" element={<OurPillars />} />
  <Route path="fees" element={<PrimaryFees />} /> 

   
</Route>
        {/* High School Section */}
        <Route path="/high-school" element={<HighSchoolLayout />}>
          <Route index element={<Home />} />
          <Route path="academics" element={<Academics />} />
          <Route path="facilities" element={<HighSchoolFacilities />} />
          <Route path="contact" element={<Contact />} />
          <Route path="our-pillars" element={<OurPillars />} />
          <Route path="how-to-pay" element={<HowToPay />} />
        </Route>
        <Route path="/admission" element={<Admissions />} />
      </Routes>
    </Router>
    
  );
}

export default App;
